import { render, staticRenderFns } from "./UiSideModal.vue?vue&type=template&id=b59691e4&scoped=true"
import script from "./UiSideModal.vue?vue&type=script&lang=js"
export * from "./UiSideModal.vue?vue&type=script&lang=js"
import style0 from "./UiSideModal.vue?vue&type=style&index=0&id=b59691e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b59691e4",
  null
  
)

export default component.exports